module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAAQ0lEQVQ4y2P4jwQ+MAww7wADDNgPDp79/z+DgscPDJ8D/IOGB2Qw/x8MPGAgARPOYOIhpZ4B5iFibMB5gyVPD56yDgA50b31kC3E+wAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNjo0MyswOTowMHkN2/UAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjYrMDk6MDDL5wzeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00220_100x100.png
// module id = MA/o
// module chunks = 0